const searchStrip = {
  hotels: "Khách sạn", // translated 
  city: "Thành phố", // translated 
  checkIn: "Đăng ký vào", // translated 
  checkOut: "Hãy xem", // translated 
  date: "Ngày", // translated 
  persons: "Người", // translated 
  adults: "Người lớn", // translated 
  rooms: "Phòng", // translated 
  editSearch: "Chỉnh sửa tìm kiếm", // translated 
  newSearch: "Tìm kiếm mới", // translated 
  listView: "Chế độ xem danh sách", // translated 
  mapView: "Chế độ xem bản đồ", // translated 
};


export default searchStrip;
